@import './../components/style.module.less';

.body {
  padding: @modal-padding;
  display: grid;
  grid-template-columns: @column-width @column-width;
  column-gap: 40px;

  @media (max-width: 650px) {
    display: block;
  }
}

.loading-indicator {
  height: 80px;
}
